import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { profileService, profileServiceQuality } from 'src/app/app-models/realTimeModels';
import { realTimeService } from 'src/app/services/services/realtime.service';

@Component({
    selector: 'app-profile-dialog',
    templateUrl: './profile-dialog.component.html',
    styleUrls: ['./profile-dialog.component.scss'],
    standalone: false
})

export class ProfileDialogComponent implements OnInit {
    @Input() public data: any = {};
    public userId: number;
    public profiles: profileService[]=[];
    constructor(
        public dialogRef: MatDialogRef<ProfileDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public dialogData: any,
        private realTimeService: realTimeService
    ) { }

    ngOnInit() {
        this.data = this.dialogData || {};
        this.userId = this.data.userId;
        this.realTimeService.GetProfile(this.userId).subscribe((profiles) => {
            this.profiles = profiles.filter(profile => profile.qualities?.length > 0);
        });
    }

    closeDialog(): void {
        this.dialogRef.close();
    }

    sortQualitiesByName(qualities: profileServiceQuality[]): profileServiceQuality[] {
        return qualities.sort((a, b) => a.name.localeCompare(b.name));
    }
}
